import * as React from 'react';
import { useForm } from 'react-hook-form';
import PublicForm from '../common/PublicForm';
import { StyledFormDiv } from '../common/PublicLayout';
import Input from '../../../../commonComponents/appForm/Input';
import DropDownListField from '../../../../commonComponents/appForm/DropDownListField';
import { getDropdownOptions } from '../../../../lib/utils';
import DateField from '../../../../commonComponents/appForm/DateField';
import { familyRelationships } from '../../userProfile/formFieldsSourceData';
import SwitchField from '../../../../commonComponents/fields/SwitchField';
import { PublicClientFamily } from '../../../../models/PublicClientModels';
import { addOrUpdateClientFamilyMember } from '../../../../core/api/publicClientApi';
import { hasValue } from '../../../../lib/lib';

const PublicFamilyMemberForm = (props: Props) => {
	const { familyMember, onCancel, onSubmit } = props;
	const addNew = !hasValue(familyMember.clientId);
	const methods = useForm({ defaultValues: familyMember });
	const { signal } = new AbortController();

	const handleSubmit = async (newFamilyMember: PublicClientFamily) => {
		// eslint-disable-next-line no-param-reassign
		if (!addNew) newFamilyMember.clientId = familyMember.clientId;
		const familyMemberClientId = await addOrUpdateClientFamilyMember(newFamilyMember, signal);
		// eslint-disable-next-line no-param-reassign
		if (addNew) newFamilyMember.clientId = familyMemberClientId;
		onSubmit(newFamilyMember);
	};

	return (
		<PublicForm
			methods={methods}
			showPrimaryButtonEndIcon
			onSubmit={handleSubmit}
			onBackButtonClick={onCancel}
			continueButtonText="Add family member"
		>
			<StyledFormDiv>
				<Input label="First name" name="firstName" maxLength={50} required />
				<Input label="Last name" name="lastName" maxLength={50} required />
			</StyledFormDiv>
			<StyledFormDiv>
				<DateField label="Date of birth" name="dateOfBirth" maxDate={new Date()} />
				<DropDownListField
					label="Relationship"
					name="relationship"
					data={getDropdownOptions(familyRelationships)}
					required
				/>
			</StyledFormDiv>
			<StyledFormDiv>
				<SwitchField label="Financially dependent?" name="financiallyDependent" invertValue />
				<div />
			</StyledFormDiv>
		</PublicForm>
	);
};

export default PublicFamilyMemberForm;

interface Props {
	familyMember: PublicClientFamily;
	onCancel?: () => void;
	onSubmit: (newFamilyMember: PublicClientFamily) => void;
}
